import api from './axiosApi';

export const searchParcel = async (parcelCode, date) => {
  const { data } = await api.get(`/parcel/${parcelCode}?date=${date}`);

  return data;
};
